import { AssetLibraryBreadcrumb } from '../types';

export const BreadcrumbsFixture: AssetLibraryBreadcrumb[] = [
    {
        collectionId: '123',
        folderId: '456',
        label: 'Collection 1',
    },
    {
        collectionId: '123',
        folderId: '456',
        label: 'Folder 1',
    },
    {
        collectionId: '123',
        folderId: '456',
        label: 'Folder 2',
    },
    {
        collectionId: '123',
        folderId: '456',
        label: 'Folder 3',
    },
];
